module.exports = __webpack_public_path__ + "build/img/warningerrors.e0018b7e.png";